<template>
    <checkatyre-star-widget :identifier="identifier"></checkatyre-star-widget>
</template>

<script>
    export default {
        props: {
            identifier: String,
        },
    };
</script>

<style lang="scss" scoped>
    .reviews {
        i {
            color: #fc3;
            margin-right: 2px;
        }
    }
</style>